import React from 'react';

import { getImgixSrc } from '@utils/images';

import MobileStepWithMedia from '../MobileStepWithMedia';

interface ProFeaturesProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const PRO_FEATURES_GIF_SRC = getImgixSrc({
  path: 'tooltip/pro_features.gif',
  isEnvDependent: false,
});

const ProFeatures = ({
  handleClose,
  handleNext,
  isProSubscriber,
  step,
  totalSteps = 5,
}: ProFeaturesProps) => (
  <MobileStepWithMedia
    description="A full list of frequently updated databases and special projects."
    handleClose={handleClose}
    handleNext={handleNext}
    isProSubscriber={isProSubscriber}
    media={
      <img
        src={PRO_FEATURES_GIF_SRC}
        alt="Pro Features"
        className="h-full w-full object-cover object-top"
      />
    }
    showCloseButton={true}
    step={step}
    title="Pro Features"
    totalSteps={totalSteps}
  />
);

export default ProFeatures;
